"use client";

import { TitleH2 } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const TeamDescription = () => {
  const t = useTranslations("team.teamDescription");
  return (
    <div className="gs--page-column py-8">
      <div className="text-ring flex flex-col items-center justify-center gap-10 text-center">
        <TitleH2 title={t("title")} />
        <div className="flex flex-col gap-4">
          <p>{t("description")}</p>
          <p>{t("secondDescription")}</p>
        </div>
      </div>
    </div>
  );
};

export default TeamDescription;
